import { render } from "./OverviewTable.vue?vue&type=template&id=5f66c26c&ts=true"
import script from "./OverviewTable.vue?vue&type=script&lang=ts"
export * from "./OverviewTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__